// validationSchemas.js
import * as Yup from "yup";

const schema0 = () =>
  Yup.object({
    firstName: Yup.string().required("First name is required"),
    surName: Yup.string().required("Surname is required"),
    lastName: Yup.string().required("Last name is required"),
    gender: Yup.number().required("Last name is required"),
    photo: Yup.mixed()
      .required("Passport-size photograph is required")
      .test("fileType", "Only image files are allowed", (value) => {
        return (
          value && ["image/jpeg", "image/png", "image/jpg"].includes(value.type)
        );
      }),
    email: Yup.string()
      .email("Invalid email format")
      .required("Email is required"),
  });

const schema1 = () =>
  Yup.object({
    primaryLanguage: Yup.string().required("Primary language is required"),
    religion: Yup.string().required("Religion is required"),
    birthCertificateFile: Yup.string().required(
      "Birth certificate file is required"
    ),
  });

const schema2 = () =>
  Yup.object({
    parentRelationship: Yup.string().required(
      "Parent relationship is required"
    ),
  });

const schema3 = () =>
  Yup.object({
    parentWorkPlace: Yup.string().required("Parent's work place is required"),
    parentWorkPosition: Yup.string().required(
      "Parent's work position is required"
    ),
    parentMobilePhone: Yup.string().required(
      "Parent's mobile phone is required"
    ),
    parentEmail: Yup.string()
      .email("Invalid email format")
      .required("Parent's email is required"),
    parentAddress: Yup.string().required("Parent's address is required"),
    idNumber: Yup.string().required("Parent's address is required"),
    parentSubCity: Yup.string().required("Parent's sub city is required"),
    parentRelationshipToStudent: Yup.string().required(
      "Parent's relationship to student is required"
    ),
    idCopyFile: Yup.mixed()
      .required("Passport-size photograph is required")
      .test("fileType", "Only image files are allowed", (value) => {
        return (
          value && ["image/jpeg", "image/png", "image/jpg"].includes(value.type)
        );
      }),
  });

const schema4 = (isHealthCheckMandatory) =>
  Yup.object({
    referenceHospital: Yup.string().when([], {
      is: () => isHealthCheckMandatory,
      then: (schema) => schema.required("Required"),
      otherwise: (schema) => schema.notRequired(),
    }),
    doctorName: Yup.string().when([], {
      is: () => isHealthCheckMandatory,
      then: (schema) => schema.required("Required"),
      otherwise: (schema) => schema.notRequired(),
    }),
    doctorNumber: Yup.string().when([], {
      is: () => isHealthCheckMandatory,
      then: (schema) => schema.required("Required"),
      otherwise: (schema) => schema.notRequired(),
    }),
    hospitalNumber: Yup.string().when([], {
      is: () => isHealthCheckMandatory,
      then: (schema) => schema.required("Required"),
      otherwise: (schema) => schema.notRequired(),
    }),
    healthDescription: Yup.string().when([], {
      is: () => isHealthCheckMandatory,
      then: (schema) => schema.required("Required"),
      otherwise: (schema) => schema.notRequired(),
    }),
    vaccinationStatus: Yup.string().when([], {
      is: () => isHealthCheckMandatory,
      then: (schema) => schema.required("Required"),
      otherwise: (schema) => schema.notRequired(),
    }),
  });
const schema5 = (isHealthIssueRequired) =>
  Yup.object({
    healthIssues: Yup.array().of(
      Yup.object({
        issueName: Yup.string().when([], {
          is: () => isHealthIssueRequired,
          then: (schema) => schema.required("Issue name is required"),
          otherwise: (schema) => schema.notRequired(),
        }),
        issueType: Yup.string().when([], {
          is: () => isHealthIssueRequired,
          then: (schema) => schema.required("Issue type is required"),
          otherwise: (schema) => schema.notRequired(),
        }),
      })
    ),
  });

const schema6 = (isAcademicRequired) =>
  Yup.object({
    schoolName: Yup.string().when([], {
      is: () => isAcademicRequired,
      then: (schema) => schema.required("School name is required"),
      otherwise: (schema) => schema.notRequired(),
    }),
    schoolPhoneNumber: Yup.string().when([], {
      is: () => isAcademicRequired,
      then: (schema) => schema.required("School phone number is required"),
      otherwise: (schema) => schema.notRequired(),
    }),
    gradeFrom: Yup.number().when([], {
      is: () => isAcademicRequired,
      then: (schema) => schema.required("Grade From is required"),
      otherwise: (schema) => schema.notRequired(),
    }),
    gradeTo: Yup.number().when([], {
      is: () => isAcademicRequired,
      then: (schema) => schema.required("Grade To is required"),
      otherwise: (schema) => schema.notRequired(),
    }),
    entryDate: Yup.date().when([], {
      is: () => isAcademicRequired,
      then: (schema) => schema.required("Entry date is required"),
      otherwise: (schema) => schema.notRequired(),
    }),
    exitDate: Yup.date().when([], {
      is: () => isAcademicRequired,
      then: (schema) => schema.required("Exit date is required"),
      otherwise: (schema) => schema.notRequired(),
    }),
    schoolAddress: Yup.string().when([], {
      is: () => isAcademicRequired,
      then: (schema) => schema.required("School address is required"),
      otherwise: (schema) => schema.notRequired(),
    }),
  });

const validationSchemas = [
  schema0, // for steps student and parent basic info
  schema1, // for student additional info
  schema2, // for parent student relationship
  schema3, // for parent additional info
  schema4, // for  health info
  schema5, // for health issue
  schema6, // for academic history
];

export default validationSchemas;
